import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { ComponentService } from '../../../services/component.service';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-device-targeting',
	templateUrl: './device-targeting.component.html',
	styleUrls: ['./device-targeting.component.scss']
})
export class DeviceTargetingComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('dtForm', { static: true }) dtForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	submitted: Boolean = false;
	formSubscription: Subscription;
	previewPromiseSubscription: Subscription;
	isPreviewPromiseCompleted: Boolean;
	heightFocus;
	widthFocus;
	isAdmin;

	constructor(private componentService: ComponentService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.previewPromiseSubscription = this.componentService.isPreviewPromiseCompleted.subscribe(
			(res) => (this.isPreviewPromiseCompleted = res)
		);

		this.formSubscription = this.dtForm.valueChanges
			.pipe(
				tap(() => {
					this.componentService.updateDisabledSave(
						(this.dtForm.dirty && this.dtForm.invalid) || this.nameField.editComponentName
					);
					this.submitted = false;
				}),
				filter((form) => Boolean(this.dtForm.dirty && this.dtForm.valid && this.isPreviewPromiseCompleted)),
				tap(() => this.componentService.updateComponentData(this.componentData)),
				debounceTime(1000),
				tap(() => (this.submitted = true))
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.formSubscription.unsubscribe();
		this.previewPromiseSubscription.unsubscribe();
	}

	updateWidget(): void {
		this.submitted = true;
		this.componentService.updateComponentData(this.componentData);
	}

	onItemImageChange(event: any, index: number): void {
		// console.log(this.componentData.config)
		const u = String(event && event.url);
		const w = Number(event && event.width ? event.width : this.componentData.config['item_width']);
		const h = Number(event && event.height ? event.height : this.componentData.config['item_height']);

		this.componentData.config.items[index].image = u;
		this.componentData.config['item_width'] = w;
		this.componentData.config['item_height'] = h;
		this.updateWidget();
	}
}
